<template>
  <questions-table
    v-model="innerModel"
    view="archived"
    @restore-question="onQuestionRestore"
  />
</template>

<script>
import questionsTable from './table'

export default {
  components: {
    questionsTable
  },
  props:{
    value: {type:Array, default:null}
  },
  data(){
    return {
      innerModel: []
    }
  },
  watch: {
    value(val){
      if(val != this.innerModel){
        this.innerModel = val
      }
    }
  },
  methods:{
    onQuestionEditing(q){
      this.$emit('edit-question', q)
    },
    onQuestionDelete(q){
      this.$emit('delete-question', q)
    },
    onQuestionRestore(q){
      this.$emit('restore-question', q)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/archived.vue